import { FieldMap, FieldMapValue, Form, InfoStage, InputSize, ShareCorrections } from '@hb/shared'
import { createContext, FC, useContext } from 'react'
import { OnStageSubmit, RenderStageComponent } from '../renderStage/types'

export interface FormWizardContextData {
  stage: FieldMap | InfoStage | null
  stageId: string | null
  open: (stageId: string) => void
  storagePath: string | null
  form: Form
  close: () => void
  onSubmitStage: OnStageSubmit
  assessmentId: string | null
  patientId: string | null
  data: FieldMapValue
  corrections: (FieldMapValue & { correctionsShared?: ShareCorrections | null }) | null
  readOnly?: boolean
  RenderStage: RenderStageComponent | null
  ReadOnlyFooter?: FC
  adminView?: boolean
  nextStage: string | null
  inputSize?: InputSize
}

export const FormWizardContext = createContext<FormWizardContextData>({
  open: () => {},
  close: () => {},
  form: {
    name: 'ERROR: Outside of form wizard context',
    description: 'ERROR: Outside of form wizard context',
    stages: {},
  },
  adminView: false,
  stage: null,
  assessmentId: null,
  patientId: '',
  stageId: null,
  storagePath: null,
  RenderStage: null,
  onSubmitStage: async () => ({ error: 'No id selected' }),
  nextStage: null,
  data: {},
  corrections: null,
})

export const useFormWizard = () => useContext(FormWizardContext)
